import { Button, Checkbox, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../../../components/PageLayout';
import { Action, GET, IfElse, errorCatch } from 'fennec-ui';
import YImage from '../../../../../common/YImage';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { goTo } from '../../../../../common/Tool';
import FedTooltip from '../../../../components/Tooltip';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function KuratorEventsByID(props) {
    let { id } = useParams();
    const { auth } = props;
    const sourceKey = "kurator";

    const [event, setEvent] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
            ({ data }) => {
                if (data && data.length) {
                    setEvent(data[0]);
                }
            }, errorCatch);
    }, [])

    return (
        <PageLayout hideSider={true}>
            <div style={{ backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
                <div style={{ textAlign: "center", padding: "26px" }}>
                    <div style={{ fontSize: "18px", fontWeight: "100" }}>Мероприятие</div>
                    <div style={{ fontSize: "29px", fontWeight: "600", lineHeight: "36px" }}>
                        <a href={`/fed/event/${event?.ID}`}>{event?.nazvanieMeropriyatiya}</a>
                    </div>
                    <div style={{ fontSize: "25px", fontWeight: "600", lineHeight: "30px" }}>г. {event?.mestoProvedeniya?.name}</div>
                </div>
                <div style={{ padding: "15px 0px", display: "flex", gap: "15px" }}>
                    <div style={{ flex: "0 0 210px", maxWidth: "210px" }}>
                        <div style={{ width: "210px", height: "210px", overflow: "hidden", borderRadius: "6px" }}>
                            <YImage item={event} width={210} />
                        </div>
                        <div style={{ marginTop: "7px" }}>
                            <div style={{
                                backgroundColor: "#eaeaea",
                                fontSize: "16px",
                                fontWeight: "400",
                                color: "black",
                                borderRadius: "6px",
                                textAlign: "center",
                                padding: "0 7px",
                                textAlign: "center",
                            }}>
                                <div style={{
                                    borderRadius: "5px",
                                    backgroundColor: "#f6214b",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "white",
                                    margin: "0 -7px",
                                    boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                    padding: "3px 7px"
                                }}>
                                    {dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                                </div>
                                <div style={{
                                    fontSize: "10px",
                                    fontWeight: "400",
                                    padding: "0px"
                                }}>
                                    {dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                </div>
                            </div>
                        </div>

                        <div>
                            {(dayjs().isBetween(event?.nachaloRegistratsii, event?.okonchanieSorevnovaniya, 'minute', '[]')) && <div style={{ marginTop: "5px" }}>
                                <a
                                    style={{ width: "100%", minWidth: "92px", fontSize: "14px" }}
                                    className={`btn btn-primary btn-sm`}
                                    href={`/app/pay/${event?.ID}`}
                                    target="_blank"
                                    rel="noreferrer noopener">Купить билет</a>
                            </div>}
                            <div style={{ marginTop: "5px" }}>
                                <a
                                    style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-success btn-sm"
                                    href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${event?.ID}`} target="_blank" rel="noreferrer noopener">
                                    Войти в мероприятие
                                </a>
                            </div>
                            {IfElse((event?.avatarTemplateMeropriyatie && event?.avatarTemplateMeropriyatie?.length),
                                (<div style={{ marginTop: "5px" }}>
                                    <a
                                        style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-secondary btn-sm"
                                        href={`/app/common/events/${event?.ID}/avatar`} rel="noreferrer noopener">
                                        Аватарка "по-быстрому"
                                    </a>
                                </div>), <></>)}

                            {IfElse(dayjs(event?.nachaloSorevnovaniya).isBefore(dayjs()),
                                (<div style={{ marginTop: "5px" }}>
                                    <a
                                        style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-secondary btn-sm"
                                        href={`/app/event/${event?.ID}/myresult`} rel="noreferrer noopener">
                                        Мои оценки
                                    </a>
                                </div>), <></>)}
                        </div>
                    </div>
                    <div style={{ flex: "1 1 auto", overflowX: "auto" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Action
                                auth={auth}
                                action={(values, unlock, close) => {
                                    if (!!values.showdisplay) {
                                        close();
                                        goTo(`/app/reports/register-jac-table/${id}?showdisplay=true&showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}`)

                                        // var a = document.createElement("a");
                                        // document.body.appendChild(a);
                                        // a.style = "display: none";
                                        // return function (data, name, type) {
                                        //     a.href = `/api/report/register-jac-table/${id}?showdisplay=true&showempty=${!!values.showempty}`;
                                        //     a.target = "_blank"
                                        //     a.click();
                                        //     a.remove();
                                        // };
                                    } else {
                                        auth.fetchFile(`/api/report/register-jac-table/${id}?showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}&showdisplay=${!!values.showdisplay}`)
                                            .then(async (res) => {
                                                close();
                                            });
                                    }
                                }}
                                modal={{
                                    title: "Первичные основные направления и регистрация на соревнования" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                                }}
                                okText="Построить отчет"
                                mode={"func"}
                                form={(props) => {
                                    const { auth, form, submit } = props;
                                    return (
                                        <Form
                                            form={form}
                                            onFinish={submit}
                                            labelAlign={"left"}
                                            layout={"vertical"}
                                            initialValues={{
                                                showbasic: false,
                                                showcategory: true,
                                                showempty: false,
                                                showdisplay: false
                                            }}
                                        >
                                            <Form.Item name="showbasic" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать основные направления
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showcategory" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать категории участников
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showempty" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать пустые
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showdisplay" valuePropName="checked">
                                                <Checkbox>
                                                    Вывести на экран
                                                </Checkbox>
                                            </Form.Item>
                                        </Form>
                                    )
                                }}
                                trigger={(click) => (
                                    <div>
                                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Первичные основные направления и регистрация на соревнования</Button>
                                    </div>
                                )}
                            />
                            <FedTooltip title="Таблица распределения участников по категориям" />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Action
                                auth={auth}
                                action={(values, unlock, close) => {
                                    if (!!values.showdisplay) {
                                        close();
                                        goTo(`/app/reports/register-jac-table-by-dancer-event/${id}?showdisplay=true&showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}`)
                                    } else {
                                        auth.fetchFile(`/api/report/register-jac-table-by-dancer-event/${id}?showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}&showdisplay=${!!values.showdisplay}`)
                                            .then(async (res) => {
                                                close();
                                            });
                                    }
                                }}
                                modal={{
                                    title: "Текущие основные направления и регистрация на соревнования" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                                }}
                                okText="Построить отчет"
                                mode={"func"}
                                form={(props) => {
                                    const { auth, form, submit } = props;
                                    return (
                                        <Form
                                            form={form}
                                            onFinish={submit}
                                            labelAlign={"left"}
                                            layout={"vertical"}
                                            initialValues={{
                                                showbasic: false,
                                                showcategory: true,
                                                showempty: false,
                                                showdisplay: false
                                            }}
                                        >
                                            <Form.Item name="showbasic" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать основные направления
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showcategory" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать категории участников
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showempty" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать пустые
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showdisplay" valuePropName="checked">
                                                <Checkbox>
                                                    Вывести на экран
                                                </Checkbox>
                                            </Form.Item>
                                        </Form>
                                    )
                                }}
                                trigger={(click) => (
                                    <div>
                                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Текущие основные направления и регистрация на соревнования</Button>
                                    </div>
                                )}
                            />
                            <FedTooltip title="Таблица распределения участников по категориям" />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Action
                                auth={auth}
                                action={(values, unlock, close) => {
                                    if (!!values.showdisplay) {
                                        close();
                                        goTo(`/app/reports/total-payment-table/${id}/${sourceKey}?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}`)

                                        // var a = document.createElement("a");
                                        // document.body.appendChild(a);
                                        // a.style = "display: none";
                                        // return function (data, name, type) {
                                        //     a.href = `/api/report/total-payment-table/${id}/${sourceKey}?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}`;
                                        //     a.target = "_blank"
                                        //     a.click();
                                        //     a.remove();
                                        // };
                                    } else {
                                        auth.fetchFile(`/api/report/total-payment-table/${id}/${sourceKey}?showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}&showdisplay=${!!values.showdisplay}`)
                                            .then(async (res) => {
                                                close();
                                            });
                                    }

                                }}
                                modal={{
                                    title: "Текущая таблица продаж" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                                }}
                                okText="Построить отчет"
                                mode={"func"}
                                form={(props) => {
                                    const { auth, form, submit } = props;
                                    return (
                                        <Form
                                            form={form}
                                            onFinish={submit}
                                            labelAlign={"left"}
                                            layout={"vertical"}
                                            initialValues={{
                                                showempty: true,
                                                showpromo: true,
                                                showsum: true,
                                                showemail: true,
                                                showcomment: true,
                                                showdisplay: true,
                                            }}
                                        >
                                            <Form.Item name="showempty" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать пустые
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showpromo" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать промокоды
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showsum" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать общую сумму покупки
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showemail" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать e-mail и телефон
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showcomment" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать комментарии
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showdisplay" valuePropName="checked">
                                                <Checkbox>
                                                    Вывести на экран
                                                </Checkbox>
                                            </Form.Item>
                                        </Form>
                                    )
                                }}
                                trigger={(click) => (
                                    <div>
                                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Текущая таблица продаж</Button>
                                    </div>
                                )}
                            />
                            <FedTooltip title={"В строках - участник, указана последняя дата покупки. \"Плюсики\" в ячейках."} />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Action
                                auth={auth}
                                action={(values, unlock, close) => {
                                    if (!!values.showdisplay) {
                                        close();
                                        goTo(`/app/reports/extended-total-payment-table/${id}/${sourceKey}?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}`)
                                    } else {
                                        auth.fetchFile(`/api/report/total-payment-table/${id}/${sourceKey}?showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}&showdisplay=${!!values.showdisplay}&extended=true`)
                                            .then(async (res) => {
                                                close();
                                            });
                                    }

                                }}
                                modal={{
                                    title: "Расширенная текущая таблица продаж" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                                }}
                                okText="Построить отчет"
                                mode={"func"}
                                form={(props) => {
                                    const { auth, form, submit } = props;
                                    return (
                                        <Form
                                            form={form}
                                            onFinish={submit}
                                            labelAlign={"left"}
                                            layout={"vertical"}
                                            initialValues={{
                                                showempty: true,
                                                showpromo: true,
                                                showsum: true,
                                                showemail: true,
                                                showcomment: true,
                                                showdisplay: true,
                                            }}
                                        >
                                            <Form.Item name="showempty" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать пустые
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showpromo" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать промокоды
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showsum" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать общую сумму покупки
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showemail" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать e-mail и телефон
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showcomment" valuePropName="checked">
                                                <Checkbox>
                                                    Показывать комментарии
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item name="showdisplay" valuePropName="checked">
                                                <Checkbox>
                                                    Вывести на экран
                                                </Checkbox>
                                            </Form.Item>
                                        </Form>
                                    )
                                }}
                                trigger={(click) => (
                                    <div>
                                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Расширенная текущая таблица продаж</Button>
                                    </div>
                                )}
                            />
                            <FedTooltip title={"В строках - участник, указана последняя дата покупки. Суммы покупок в ячейках."} />
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
